import {ExternalLinkHandlerBase} from "../external-link-handler-base";
import {IHelpExternalLinkHandler} from "./help.external-link-handler.interface";

export class HelpExternalLinkHandler extends ExternalLinkHandlerBase implements IHelpExternalLinkHandler {
    async openHelpPage(): Promise<void> {
        await this.services.linksNavigation.navigateLink({
            linkId: "helpLink"
        });
    }
}